import { render, staticRenderFns } from "./dashboardAccordion.vue?vue&type=template&id=df7c6da6&"
import script from "./dashboardAccordion.vue?vue&type=script&lang=js&"
export * from "./dashboardAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports